/**
 * BuildInfo.tsx
 * Bottom-right corner watermark showing commit SHA, build date/time.
 * Baked in at build time via REACT_APP_* env vars.
 */

import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

const COMMIT_SHA  = process.env.REACT_APP_COMMIT_SHA  ?? '';
const SHORT_SHA   = COMMIT_SHA ? COMMIT_SHA.slice(0, 7) : (process.env.REACT_APP_VERSION ?? 'dev');
const BUILD_DATE  = process.env.REACT_APP_BUILD_DATE  ?? '';
const BUILD_TIME  = process.env.REACT_APP_BUILD_TIME  ?? '';

const BuildInfo: React.FC = () => {
  const [expanded, setExpanded] = useState(false);

  if (!SHORT_SHA && !BUILD_DATE) return null;

  const label = expanded
    ? [SHORT_SHA, BUILD_DATE, BUILD_TIME].filter(Boolean).join(' · ')
    : SHORT_SHA || BUILD_DATE;

  return (
    <Box
      onClick={() => setExpanded(v => !v)}
      sx={{
        position:   'fixed',
        bottom:     8,
        right:      10,
        zIndex:     9999,
        cursor:     'pointer',
        userSelect: 'none',
        display:    'flex',
        alignItems: 'center',
        gap:        '5px',
        opacity:    0.35,
        transition: 'opacity 0.2s',
        '&:hover':  { opacity: 0.75 },
      }}
    >
      {/* Git branch icon */}
      <Box component="span" sx={{ fontSize: '9px', color: 'rgba(255,255,255,0.8)', lineHeight: 1 }}>
        ⎇
      </Box>
      <Typography
        sx={{
          fontSize:      '10px',
          color:         'rgba(255,255,255,0.8)',
          letterSpacing: '0.04em',
          fontFamily:    'monospace',
          lineHeight:    1,
          whiteSpace:    'nowrap',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default BuildInfo;
